import script from "./ResizeHandler.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResizeHandler.vue?vue&type=script&lang=ts&setup=true"

import "./ResizeHandler.vue?vue&type=style&index=0&id=1e66197f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e66197f"]])

export default __exports__